import { Component } from '@theme/component';

class ProductTitle extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.applyTwoLineTitle();
  }

  applyTwoLineTitle() {
    const textElement = this.refs?.text || this.querySelector('.title-text') || this;

    this.style.display = 'block';
    this.style.lineHeight = '1.3';
    this.style.height = '2.6em';
    this.style.minHeight = '2.6em';
    this.style.maxHeight = '2.6em';
    this.style.overflow = 'hidden';

    textElement.style.display = '-webkit-box';
    textElement.style.webkitBoxOrient = 'vertical';
    textElement.style.webkitLineClamp = '2';
    textElement.style.overflow = 'hidden';
    textElement.style.textOverflow = 'ellipsis';
  }
}

if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}

export default ProductTitle;